import React from 'react';
import { StyledSubTitle } from './styled.subtitle';
import { ISubTitle } from '../../../@types/subTitle';

export function SubTitle ({children, textDecoration}: ISubTitle) {
    return(
        <StyledSubTitle textDecoration={textDecoration}>
            {children}
        </StyledSubTitle>
    );
}
